import ask from '@/utils/http'

export default {
  // 添加企业微信参数
  addEnterpriseWechat: (params = {}) => ask.post(`/backstage/addEnterpriseWechat`, params),
  // 获取企业微信参数
  getEnterpriseWechat: (params = {}) => ask.get(`/backstage/getEnterpriseWechat`, params),
}



// WEBPACK FOOTER //
// ./src/api/enterpriseWechat.js